import { yupResolver } from "@hookform/resolvers/yup/dist/yup";
import { useForm } from "react-hook-form";
import APIS from "../../constant/EndPoint";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
//@ts-ignore
import { FormLayout } from "@careinfo/layout";
import { createRunsheetValidationForm } from "../../utils/validationSchemas";
import ComboboxInput from "../Reusable/ComboboxInput";
import TextField from "../Reusable/TextInput";
import Modal from "../Reusable/Modal";
import DriverForm from "./DriverForm";
import VehicleForm from "./VehicleForm";
import { useEffect, useState } from "react";

const CreateRunsheet = (props: any) => {
  const {
    handleCreate,
    isLoading,
    defaultBranch,
    handleAddVehicle,
    isVehicleLoading,
  } = props;
  const [openAddVehiclePopup, setOpenAddVehiclePopup] = useState(false);
  const [openAddDriverPopup, setOpenAddDriverPopup] = useState(false);

  const {
    register,
    handleSubmit,
    formState: { errors },
    setError,
    setValue,
    getValues,
    clearErrors,
  } = useForm<any>({
    defaultValues: async () => {
      return {
        destination_branch: defaultBranch,
      };
    },
    resolver: yupResolver(createRunsheetValidationForm),
  });

  return (
    <>
      <FormLayout
        handleSubmit={handleSubmit}
        handleFormSubmit={handleCreate}
        setError={setError}
        buttonLabel={"Submit"}
        isLoading={isLoading}
      >
        <div className={tw`mx-4`}>
          <div className={tw`grid grid-cols-3 gap-x-4 `}>
            <div className={tw`w-full flex `}>
              <div className={tw`w-full`}>
                <ComboboxInput
                  url={APIS.VEHICLE}
                  queryKey={"vehicle"}
                  register={register("vehicle")}
                  errors={errors?.vehicle}
                  name={"vehicle"}
                  label={"Vehicle Number"}
                  setValue={setValue}
                  placeholder={"Search vehicle"}
                  getValues={getValues}
                  clearErrors={clearErrors}
                />
              </div>
              <button
                className={tw`border px-4  py-2 h-10 relative top-10 focus:outline-none focus-visible:ring-2 focus-visible:ring-primary ring-offset-1`}
                type="button"
                onClick={() => setOpenAddVehiclePopup(!openAddVehiclePopup)}
              >
                +
              </button>
            </div>

            <div className={tw`w-full flex  `}>
              <div className={tw`w-full`}>
                <ComboboxInput
                  url={APIS.DRIVER}
                  queryKey={"driver"}
                  register={register("driver")}
                  errors={errors?.driver}
                  name={"driver"}
                  label={"Driver"}
                  setValue={setValue}
                  placeholder={"Search driver"}
                  getValues={getValues}
                  clearErrors={clearErrors}
                />
              </div>
              <button
                className={tw`border px-4  py-2 h-10 relative top-10 focus:outline-none focus-visible:ring-2 focus-visible:ring-primary ring-offset-1`}
                type="button"
                onClick={() => setOpenAddDriverPopup(!openAddDriverPopup)}
              >
                +
              </button>
            </div>
            <ComboboxInput
              url={APIS.BRANCH}
              queryKey={"branch"}
              register={register("destination_branch")}
              errors={errors?.destination_branch}
              name={"destination_branch"}
              label={"Destination"}
              setValue={setValue}
              placeholder={"Search branch"}
              getValues={getValues}
              clearErrors={clearErrors}
            />
          </div>
          <div>
            <TextField
              label={"Note"}
              register={register(`note`)}
              errors={errors?.note}
            />
          </div>
        </div>
      </FormLayout>
      <Modal
        isOpen={openAddVehiclePopup}
        setIsOpen={setOpenAddVehiclePopup}
        title={"Add Vehicle"}
        children={
          <>
            <VehicleForm
              register={register}
              errors={errors}
              handleSubmit={handleSubmit}
              setOpenAddVehiclePopup={setOpenAddVehiclePopup}
              handleAddVehicle={handleAddVehicle}
              isVehicleLoading={isVehicleLoading}
            />
          </>
        }
      />
      <Modal
        isOpen={openAddDriverPopup}
        setIsOpen={setOpenAddDriverPopup}
        title={"Add Driver"}
        children={
          <>
            <DriverForm
              register={register}
              errors={errors}
              handleSubmit={handleSubmit}
              setValue={setValue}
              setOpenAddDriverPopup={setOpenAddDriverPopup}
              getValues={getValues}
              clearErrors={clearErrors}
            />
          </>
        }
      />
    </>
  );
};

export default CreateRunsheet;
